import { type StoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { useMemo } from 'react'
import { useUser } from '@/features/account/services/User/hooks'
import { getLegacyStoreParams } from '@/features/shared/utils/dataFetching/storeParamsUtils'
import { useGuestParams } from '@/features/account/services/GuestUser/hooks'
import { useInferredZip } from '@/features/account/services/Zip/hooks'
import { useZipUserStore } from '@/features/shop/services/ShoppingStore/hooks'

export const useLegacyStoreParams = (): StoreParams => {
  const user = useUser()
  const inferredZip = useInferredZip()
  const zipUserStore = useZipUserStore()
  const guestParams = useGuestParams()
  const { user_id, metro_id, store_id, store_location_id, zip } = getLegacyStoreParams({
    user,
    inferredZip,
    zipUserStore,
    guestParams,
  })
  return useMemo(
    () => ({
      zip,
      user_id,
      metro_id,
      store_id,
      store_location_id,
    }),
    [user_id, metro_id, store_id, store_location_id, zip],
  )
}
